<template>
  <div class="client_request_list">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="form_select__wrap">
        <div class="form_select">
          <tree-select
              :options="client_list"
              :multiple="true"
              v-model="filter.client_ids"
              :placeholder="translate('client_request.client_name')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <fg-input
              type="text"
              v-model="filter.search"
              :placeholder="translate('search')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="form_select__wrap">
        <div class="form_select">
          <tree-select
              :options="type_list"
              :multiple="false"
              v-model="filter.type"
              :placeholder="translate('client_request.type_request')"
              :clearable="true"
              :searchable="false"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <tree-select
              :options="device_status_list"
              :multiple="false"
              v-model="filter.device_status"
              :placeholder="translate('client_request.device_status')"
              :clearable="true"
              :searchable="false"
              @input="change_input"
          />
        </div>
      </div>

      <div class="form_select__wrap">
        <div class="form_select">
          <tree-select
              :options="status_list"
              :multiple="false"
              v-model="filter.status"
              :placeholder="translate('client_request.status_request')"
              :clearable="true"
              :searchable="false"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <tree-select
              :options="device_tariffication_list"
              :multiple="false"
              v-model="filter.device_tariffication"
              :placeholder="translate('client_request.device_tariff')"
              :clearable="true"
              :searchable="false"
              @input="change_input"
          />
        </div>
      </div>

      <div class="form_select__wrap">
        <div class="form_select">
          <WrapDatePicker
              type="date"
              :placeholder="translate('client_request.period')"
              v-model="filter.date"
              :range="true"
              :confirm="true"
              value_type="YYYY-MM-DD"
              @input="change_input"
          />
        </div>


        <div class="form_select">
          <fg-input
              type="text"
              v-model="filter.fid"
              :placeholder="translate('client_request.device_fid')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="form_select__wrap">
        <div class="form_select">
          <tree-select
              :options="option_list"
              :multiple="true"
              v-model="options"
              :placeholder="translate('client_request.option_list')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>
      <div class="form_select__wrap"></div>
    </div>

    <div class="response_table">
      <div class="summary card" v-if="summary.length > 0">
        <p v-for="(sum, key) in summary" :key="key">
          <span>{{ translate("client_request.summary." + sum.name) }}:</span>
          <span v-html="sum.value" />
        </p>
      </div>
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th
                class="pointer w50"
                @click="change_filter('id')"
                :class="{ selected: filter_type === 'id' }"
                scope="col"
            >
              {{ translate('client_request.id') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer limit"
                @click="change_filter('date')"
                :class="{ selected: filter_type === 'date' }"
                scope="col"
            >
              {{ translate('client_request.date') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('type')"
                :class="{ selected: filter_type === 'type' }"
                scope="col"
            >
              {{ translate('client_request.type') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer limit"
                @click="change_filter('status')"
                :class="{ selected: filter_type === 'status' }"
                scope="col"
            >
              {{ translate('client_request.status') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer limit"
                @click="change_filter('priority')"
                :class="{ selected: filter_type === 'priority' }"
                scope="col"
            >
              {{ translate('client_request.priority') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer limit"
                @click="change_filter('simcards_state')"
                :class="{ selected: filter_type === 'simcards_state' }"
                scope="col"
            >
              {{ translate('client_request.simcards_state') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

<!--            <th-->
<!--                class="pointer w70"-->
<!--                @click="change_filter('simcard_count')"-->
<!--                :class="{ selected: filter_type === 'simcard_count' }"-->
<!--                scope="col"-->
<!--            >-->
<!--              {{ translate('client_request.working_simcard_count') }}-->
<!--              <i-->
<!--                  class="mdi mdi-arrow-down"-->
<!--                  :class="{ reverse: filter_asc === 'desc' }"-->
<!--              />-->
<!--            </th>-->

            <th
                class="pointer device_tariff w50"
                @click="change_filter('device_tariffication')"
                :class="{ selected: filter_type === 'device_tariffication' }"
                scope="col"
            >
              <span class="mdi mdi-currency-rub"></span>
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'asc' }"
              />
            </th>

            <th
                class="pointer name"
                @click="change_filter('client_name')"
                :class="{ selected: filter_type === 'client_name' }"
                scope="col"
            >
              {{ translate('client_request.client_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer w50"
                @click="change_filter('device_status')"
                :class="{ selected: filter_type === 'device_status' }"
                scope="col"
            >
              {{ translate('client_request.status') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer name w15per"
                @click="change_filter('device_name')"
                :class="{ selected: filter_type === 'device_name' }"
                scope="col"
            >
              {{ translate('client_request.device_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th class="name" scope="col" v-if="$store.getters.getPermissions.permissionGod === true">
              {{ translate('client_request.simcards') }}
            </th>

            <th class="name" scope="col">
              {{ translate('client_request.device_ver') }}
            </th>
            <th
                class="pointer name"
                @click="change_filter('device_group_name')"
                :class="{ selected: filter_type === 'device_group_name' }"
                scope="col"
            >
              {{ translate('client_request.device_group_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('user_name')"
                :class="{ selected: filter_type === 'user_name' }"
                scope="col"
            >
              {{ translate('client_request.who_created') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('ts_create')"
                :class="{ selected: filter_type === 'ts_create' }"
                scope="col"
            >
              {{ translate('client_request.created') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('ts_complete')"
                :class="{ selected: filter_type === 'ts_complete' }"
                scope="col"
            >
              {{ translate('client_request.completed') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <ClientRequestListItem
              v-for="(client_request,key) in request_list"
              :key="key"
              :client_request="client_request"
              @add_in_filter="add_in_filter"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ClientRequestListItem from "./Item/Index.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'ClientRequestList',
  components: {
    WrapDatePicker,
    ClientRequestListItem
  },
  data () {
    return {
      client_request_list: [],
      client_request_statuses: [],
      check_link: true,
      filter:{
        type: null,
        status: null,
        date: [],
        client_ids: [],
        only_active: null,
        fid: "",
        device_status: null,
        device_tariffication: null,
        search: ""
      },
      options:[],
      filter_asc: "asc",
      filter_type: "",
      summary: {},
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  computed:{
    sended_filter() {
      let filter = {};
      Object.keys(this.filter).forEach((key) => {
        if (key === 'date'){
          if (this.filter[key].length > 0 && this.filter[key][0] !== null && this.filter[key][1]){
            filter["date_start"] = this.filter[key][0]
            filter["date_end"] = this.filter[key][1]
          }
        }else if (key === "client_ids"){
          this.filter[key].length > 0 ? filter[key] = this.filter[key] : ""
        }else{
          if (this.filter[key] !== "" && this.filter[key] !== null && this.filter[key] !== undefined){
            filter[key] = this.filter[key]
          }
        }
      })
      return filter;
    },
    device_status_list(){
      return [
        {id: 1, label: this.translate("client_request.device_status_list.online")},
        {id: -1, label: this.translate("client_request.device_status_list.offline")}
      ]
    },
    device_tariffication_list(){
      return [
        {id: 1, label: this.translate("client_request.device_tariffication_list.tariffed")},
        {id: -1, label: this.translate("client_request.device_tariffication_list.untariffed")}
      ]
    },
    option_list(){
      return [
        {id: "only_active", label: this.translate("client_request.only_active")}
      ]
    },
    request_list(){
      let request_list = [...this.client_request_list];
      return request_list.sort(this.compareNumbers);
    },
    type_list(){
      return this.$store.getters.getClientRequestsInfo.types.map((entry) => {
        return { id: entry.id, label: this.translate("client_request.types." + entry.title) }
      })
    },
    status_list() {
      return this.$store.getters.getClientRequestsInfo.statuses.map((entry) => {
        return { id: entry.id, label: this.translate("client_request.statuses." + entry.title) }
      })
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return { id: client.id, label: client.name }
      })
    },
  },

  watch:{
    options:{
      deep: true,
      handler(){
        this.option_list.forEach((option) =>{
          if (this.options.indexOf(option.id) > -1){
            this.filter[option.id] = 1
          } else {
            this.filter[option.id] = null
          }
        })
      }
    },
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'client_request_list_section') {
          let string = '?'
          for (let key in this.filter) {
            switch (key) {
              case 'type':
              case 'status':
              case 'fid':
              case 'search':
              case 'only_active':
              case 'device_status':
              case 'device_tariffication':
                if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
                  string += `&${key}=${this.filter[key]}`
                }
                break;
              case 'client_ids':
                if (this.filter[key].length > 0){
                  string += `&${key}=${this.filter[key]}`
                }
                break;
            }
          }
          history.replaceState(null, null, this.$route.path + string)
        }
      }
    },
    "filter.fid":{
      handler(){
        this.filter.fid = this.filter.fid.replace(" ", "")
      }
    },
  },

  created () {
    this.check_query()
  },

  activated () {
    this.check_query()
  },

  deactivated() {
    this. filter = {
      type: null,
      status: null,
      date: [],
      client_ids: [],
      only_active: null,
      fid: ""
    }
    this.options = []
  },

  methods: {
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'fid':
            case 'search':
              this.filter[key] = this.$route.query[key]
              break;
            case 'type':
            case 'status':
            case 'device_status':
            case 'device_tariffication':
              this.filter[key] = Number(this.$route.query[key])
              break;
            case 'only_active':
              this.filter[key] = Number(this.$route.query[key])
              if(!(this.options.indexOf(key) > -1)){
                this.options.push(key)
              }
              break;

            case 'client_ids':
              this.filter[key] = this.$route.query[key].split(',').map(item => {
                return Number(item)
              })
              break;
          }
        }
      }
      this.load_client_requests()
    },
    add_in_filter(params){
      this.filter[params.type] = params.value
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.load_client_requests, 500)
    },
    load_client_requests(){
      this.$http.v1.getClientRequestList(this.sended_filter, (response) => {
        if (response.data){
          this.client_request_list = response.data.data
          this.summary = response.data.summary
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>
.client_request_list{
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 20px;

  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    margin-top: 10px;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .btn{
        width: 30%;
      }
    }
    .form_select{
      margin-bottom: 10px;
      &:last-child{
        margin-bottom: 0;
      }
      &__wrap{
        flex: 1;
      }
      .vue-treeselect{
        margin-bottom: 0;
      }
      .form-group{
        margin: 0;
      }
    }
  }

  .client_request{
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    td{
      overflow: hidden;
    }
  }
  .response_table{
    flex: 10;
    padding: 10px 0 0;
    table{
      tbody{
        .online{
          color: #15ab00;
        }
        span{
          font-size: 22px;
        }
      }
      th {
        font-size: 12px;
        &.limit{
          width: 6%;
          min-width: 100px;
        }
      }
    }
  }
}


@media (max-width: 500px){
  .header{
    .form{
      width: 100%;
      .filter{
        min-width: max-content;
        margin: 0 10px;
      }
    }
    .btn{
      b{
        display: none;
      }
      width: 20%;
      min-width: inherit;
    }
  }

}
</style>
